var map = {
	"./akkord.png": 382,
	"./alf.png": 6403,
	"./algol.png": 3931,
	"./alliance.png": 7345,
	"./anex.png": 6492,
	"./coral.png": 8915,
	"./joinup.png": 1625,
	"./kompas.png": 3451,
	"./pegas.png": 8216,
	"./tango.png": 4255,
	"./teztour.png": 9011,
	"./tpg.png": 1299,
	"./tui.png": 122,
	"./zabugor.png": 1712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4689;